import Vue from 'vue'
import Notification from './Notification'
import Loading from './Loading'

Vue.use(Notification)
Vue.use(Loading)
